"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const notistack_1 = require("notistack");
const AppRoutes_1 = require("./AppRoutes");
const mode = process.env.MODE || "standalone";
const App = () => {
    console.log("App Is running");
    return ((0, jsx_runtime_1.jsx)(notistack_1.SnackbarProvider, { maxSnack: 3, anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, children: (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsx)(AppRoutes_1.AppRoutes, {}) }) }));
};
exports.default = App;
